import React, { Component } from 'react';
import {
  Button,
  Divider,
  Paper,
  TextField,
  Grid,
  Modal
} from '@material-ui/core';
import PropTypes from 'prop-types';
import isEmail from 'validator/lib/isEmail';
import i18n from '../../i18n';
import validateAgentFieldsHasErrors from '../../helpers/validationHelpers';

import StringItemSelector from './StringItemSelector';
import '../../assets/stylesheets/Setting.css';

const initialState = {
  agencyId: 0,
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: {
    Home: ''
  },
  edited: {
    agencyId: false,
    firstName: false,
    lastName: false,
    email: false,
    phoneNumber: false
  },
  error: true
};

class AddAgentModal extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  handleAdd = () => {
    const { onAddAgent } = this.props;
    const {
      error,
      agencyId,
      firstName,
      lastName,
      email,
      phoneNumber
    } = this.state;
    if (error) {
      const updatedEdited = {
        agencyId: true,
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true
      };
      this.setState({ edited: updatedEdited });
    } else {
      const agent = {
        agencyId,
        firstName,
        lastName,
        email,
        phoneNumber
      };
      onAddAgent(agent);
    }
  };

  handleChange = event => {
    event.persist();
    const { name, value } = event.target;

    if (name === 'phoneNumber') {
      this.setState(prevState => {
        return({
          phoneNumber: { 
            Home: value
          },
          edited: {
            ...prevState.edited,
            phoneNumber: true
          } 
        })}, () =>
        this.validateFields()
      );
    } else {
      this.setState(
        prevState => {
          return {
            [name]: value,
            edited: {
              ...prevState.edited,
              [name]: true
            }
          };
        },
        () => this.validateFields()
      );
    }
  };

  onAgencyChange = event => {
    const { value } = event.target;
    if (value) {
      this.setState(
        prevState => {
          return {
            agencyId: value,
            edited: {
              ...prevState.edited,
              agencyId: true
            }
          };
        },
        () => this.validateFields()
      );
    }
  };

  onClose = () => {
    const { onClose } = this.props;
    this.setState(initialState, () => onClose());
  };

  validateFields = () => {
    const { firstName, lastName, email, phoneNumber, agencyId } = this.state;
    const updatedError = validateAgentFieldsHasErrors({
      firstName,
      lastName,
      email,
      phoneNumber,
      agencyId,
    });
    this.setState({ error: updatedError });
  };

  render() {
    const { agencies, showModal } = this.props;
    const {
      edited,
      firstName,
      lastName,
      email,
      phoneNumber,
      agencyId
    } = this.state;
    return (
      <Modal open={showModal} onClose={this.onClose}>
        <Paper className="addAgentModal">
          <Grid container>
            <Grid item xs={12}>
              {i18n.t('setting:enterAgent')}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                error={edited.firstName && firstName === ''}
                id='agent firstName'
                label={i18n.t('setting:agentFirstName')}
                name="firstName"
                autoFocus
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                error={edited.lastName && lastName === ''}
                id='agent lastName'
                label={i18n.t('setting:agentLastName')}
                name="lastName"
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                error={edited.email && !isEmail(email)}
                id='agent email'
                label={i18n.t('setting:agentEmail')}
                name="email"
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                error={edited.phoneNumber && phoneNumber.Home === ''}
                id='agent phoneNumber'
                label={i18n.t('setting:agentPhoneNumber')}
                name="phoneNumber"
                onChange={this.handleChange}
              />
              <StringItemSelector
                selectedItem={agencyId}
                items={agencies}
                required
                error={edited.agencyId && agencyId === 0}
                onItemChange={this.onAgencyChange}
                label={i18n.t('setting:chooseAgency')}
                helperText={i18n.t('setting:agencyAgentHelp')}
              />
              <Divider />
              <br />
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={this.handleAdd}
                className="ssenseButton ssensePrimary"
              >
                {i18n.t('add')}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={this.onClose}
                className="ssenseButton ssenseDefault"
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
}

AddAgentModal.propTypes = {
  agencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  showModal: PropTypes.bool.isRequired,
  onAddAgent: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default AddAgentModal;
